import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import PaiementForm from './paiementForm'

interface props {
    handleConfirmPayment?:any
    clientSecret: string
    functionTracks:any
    urlConfirmedPayment: string
    loadingUrlConfirmed: boolean
    amountPaid?:number
}
const Paiement: React.FC<props> = ({ handleConfirmPayment, clientSecret, functionTracks, urlConfirmedPayment, loadingUrlConfirmed, amountPaid }) => {
    const stripePromise = loadStripe(
        // 'pk_test_51OzdEkP1vfmwjObRWZs9jeUgtjVr5yPKXnOEtrKZbJdd7boKLUA7KP6VVEmXkqJJegtrebeTm3z9plymQavS3ZwL009Vrh8Udc',
          'pk_live_51OzdEkP1vfmwjObRvRrgzAJK6t50avVcC79ukYvChcLYpCQPS6fJenImQi1dJgkZQYzFtmyu4TJ3Wjbqzq2MiGKu00syVqIEXn'

      )
  return (
    <div className="sm:mt-5 xs:mt-5 5xl:flex 5xl:justify-center xs:flex xs:justify-center">
    <Elements stripe={stripePromise}> 
        <PaiementForm 
          handleConfirmPayment={handleConfirmPayment}
          clientSecret={clientSecret}
          functionTracks={functionTracks}
          urlConfirmedPayment={urlConfirmedPayment}
          loadingUrlConfirmed={loadingUrlConfirmed}
          amountPaid={amountPaid}
        /> 
      </Elements> 
  </div>
  )
}
export default Paiement
